/**
 * 共有端末の時間選択画面で表示するダイアログのメッセージキー
 */
export const MESSAGE_KEY = {
  /** 満室: 営業時間内だが全て予約済み */
  FULLY_BOOKED: 'fullyBooked',
  /** 営業時間外: 選択可能なスロットがない */
  OUTSIDE_BUSINESS_HOURS: 'outsideBusinessHours',
} as const;

export type MessageKey = (typeof MESSAGE_KEY)[keyof typeof MESSAGE_KEY];
